import moment from 'moment'

export function applyTimeMask(raw: string, isDelete = false): string {
  const d = raw.replace(/\D/g, '').slice(0, 6)
  let h = d.slice(0, 2)
  let m = d.slice(2, 4)
  let s = d.slice(4, 6)

  if (h.length === 1 && +h > 2) h = '0' + h
  if (h.length === 2 && +h > 23) h = '23'
  if (m.length === 1 && +m > 5) m = '0' + m
  if (m.length === 2 && +m > 59) m = '59'
  if (s.length === 1 && +s > 5) s = '0' + s
  if (s.length === 2 && +s > 59) s = '59'

  let out = h
  if (h.length === 2 && (m.length > 0 || !isDelete)) out += ':' + m
  if (m.length === 2 && (s.length > 0 || !isDelete)) out += ':' + s
  return out
}

export function applyDateMask(raw: string, isDelete = false): string {
  const d = raw.replace(/\D/g, '').slice(0, 8)
  let dd = d.slice(0, 2)
  let mm = d.slice(2, 4)
  const yy = d.slice(4, 8)

  if (dd.length === 1 && +dd > 3) dd = '0' + dd
  if (dd.length === 2) {
    if (+dd === 0) dd = '01'
    else if (+dd > 31) dd = '31'
  }

  if (mm.length === 1 && +mm > 1) mm = '0' + mm
  if (mm.length === 2) {
    if (+mm === 0) mm = '01'
    else if (+mm > 12) mm = '12'
  }

  let out = dd
  if (dd.length === 2 && (mm.length > 0 || !isDelete)) out += '.' + mm
  if (mm.length === 2 && (yy.length > 0 || !isDelete)) out += '.' + yy
  return out
}

export function parseISO(v: string): Date | null {
  const m = moment(v, moment.ISO_8601, true)
  return m.isValid() ? m.toDate() : null
}
